module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-whiteframe', {
    staticClass: "project-box"
  }, [_c('md-card', {
    staticClass: "project-box-content"
  }, [_c('md-card-header', [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Pending Project Invites")])]), _vm._v(" "), _c('md-card-content', _vm._l((_vm.projects), function(project) {
    return _c('md-layout', {
      key: project.id,
      staticClass: "project-box-container md-row",
      attrs: {
        "md-flex": "25"
      }
    }, [_c('h1', {
      staticClass: "md-subheader pending-subheader"
    }, [_vm._v(_vm._s(project.title))]), _vm._v(" "), _c('md-button', {
      staticClass: "md-mini md-fab pending-action-button",
      on: {
        "click": function($event) {
          _vm.accept(project)
        }
      }
    }, [_c('md-icon', [_vm._v("person_add")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Join Project")])], 1), _vm._v(" "), _c('md-button', {
      staticClass: "md-mini md-fab pending-action-button",
      on: {
        "click": function($event) {
          _vm.decline(project)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Cancel Invite")])], 1)], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a541338a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/dashboard/pending-projects.vue
// module id = 676
// module chunks = 2